module.exports = require('./lib/noGetters');



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/react-lazy-cache/noGetters.js
// module id = 605
// module chunks = 0 3 5